import { useState, useEffect, useMemo, useCallback } from "react"
import qs from "qs"

import server from "server/serverController2"

const useOrderDetail = ({ orderNo }) => {
  const [orderData, setOrderData] = useState(null)

  const loadOrderData = useMemo(async () => {
    try {
      const queryString = qs.stringify({
        is_show_shipping_data: true,
        is_show_payment_data: true,
        show_order_items: true,
      })
      const response = await server.getRequestData(`commerce/orders/${orderNo}?${queryString}`)

      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData.detail_code
      }

      const { order } = response.data

      return order
    } catch (error) {
      console.log(error)
    }
  }, [orderNo])

  const handleSetOrderData = useCallback(async () => {
    const order = await loadOrderData
    setOrderData(order)
  }, [loadOrderData])

  useEffect(() => {
    if (orderNo) {
      handleSetOrderData()
    }

    return () => setOrderData(null)
  }, [orderNo, handleSetOrderData])

  return { orderData }
}

export default useOrderDetail
